// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__Kkn3G","overlay":"Dialog_overlay__KwgIV","content":"Dialog_content__X9xYu","close":"Dialog_close__mNdRZ","icon":"Dialog_icon__+aJUs"};